import { useAtom } from 'jotai';

import { type AtomState } from '@/ui/utilities/state/jotai/types/AtomState';

export const useAtomState = <TValue>(state: AtomState<TValue>) =>
  useAtom(state.atom);
